import { render } from "./searchIcon.vue?vue&type=template&id=9072e1ea"
import script from "./searchIcon.vue?vue&type=script&lang=js"
export * from "./searchIcon.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__